"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modal_selection_icons = exports.generate_data_example_icons = void 0;
const SankeyUtils_1 = require("open-sankey/dist/configmenus/SankeyUtils");
const lib_of_icons_json_1 = __importDefault(require("./icons/lib_of_icons.json"));
const react_bootstrap_1 = require("react-bootstrap");
const react_1 = __importStar(require("react"));
const fa_1 = require("react-icons/fa");
const d3 = __importStar(require("d3"));
const generate_data_example_icons = (get_default_data) => {
    const data_sankey = get_default_data();
    data_sankey.icon_catalog = {};
    data_sankey.style_node['default'].node_height = 100;
    data_sankey.style_node['default'].node_width = 100;
    data_sankey.style_node['default'].shape_visible = false;
    Object.keys(lib_of_icons_json_1.default).forEach((cki, nki) => {
        const ki = cki;
        Object.entries(lib_of_icons_json_1.default[ki]).forEach((i, n) => {
            data_sankey.icon_catalog[i[0]] = i[1];
            const node = (0, SankeyUtils_1.DefaultNode)(data_sankey);
            node.idNode = 'key_' + i[0];
            node.name = i[0];
            node.iconName = i[0];
            node.iconVisible = true;
            node.iconColor = 'black';
            node.x = (n * 150) + 50;
            node.y = (nki * 200) + 100;
            data_sankey.nodes[node.idNode] = node;
        });
    });
    return data_sankey;
};
exports.generate_data_example_icons = generate_data_example_icons;
const modal_selection_icons = (t, multi_selected_nodes, data, dict_hook_ref_setter_show_dialog_components, node_function) => {
    const imported_icon = localStorage.getItem('icon_imported');
    const init_imported_svg = imported_icon != null && imported_icon !== '' ? JSON.parse(imported_icon) : {};
    const [modale_sub_icon, set_modale_sub_icon] = (0, react_1.useState)(Object.keys(lib_of_icons_json_1.default)[0] !== undefined ? Object.keys(lib_of_icons_json_1.default)[0] : '');
    const [filter_name, set_filter_name] = (0, react_1.useState)('');
    const _load_svg = (0, react_1.useRef)(null);
    const import_svg = (0, react_1.useRef)(init_imported_svg);
    const [s_show_modal, sShowModal] = (0, react_1.useState)(false);
    dict_hook_ref_setter_show_dialog_components.ref_setter_show_modal_import_icons.current = sShowModal;
    const isAllIconVisible = () => {
        let selected_icon = '';
        if (multi_selected_nodes.current.length > 0) {
            selected_icon = multi_selected_nodes.current[0].iconName;
        }
        multi_selected_nodes.current.map(d => selected_icon = (d.iconName === selected_icon) ? selected_icon : '');
        return selected_icon;
    };
    const allSelectedNodeHasSameicon = isAllIconVisible();
    multi_selected_nodes.current.length > 0 ? multi_selected_nodes.current[0].iconName : 'None';
    // Create object containing list of card elements regrouped by the icon themes
    const tuto_sub_nav = {};
    {
        Object.keys(lib_of_icons_json_1.default).map((cki) => {
            const ki = cki;
            tuto_sub_nav[ki] = react_1.default.createElement(react_1.default.Fragment, null, Object.entries(lib_of_icons_json_1.default[ki]).filter(ic => {
                return filter_name === '' ? true : t(ki + '.' + ic[0]).includes(filter_name);
            }).sort(([a,], [b,]) => (t(ki + '.' + a) > t(ki + '.' + b)) ? 1 : ((t(ki + '.' + b) > t(ki + '.' + a)) ? -1 : 0)).map(icon => {
                // icon[0]:Name of the icon
                // icon[1]:Path of the icon
                return react_1.default.createElement(react_bootstrap_1.Card, { style: { borderWidth: allSelectedNodeHasSameicon === ki + '_' + icon[0] ? '2px' : '1px' }, border: (allSelectedNodeHasSameicon === ki + '_' + icon[0]) ? 'primary' : 'light', onClick: () => {
                        data.icon_catalog[ki + '_' + icon[0]] = icon[1];
                        Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                            d.iconName = ki + '_' + icon[0];
                            d.iconColor = '#000000';
                            delete d.iconViewBox;
                        });
                        node_function.reDrawIllustration(multi_selected_nodes.current);
                        sShowModal(false);
                    } },
                    react_1.default.createElement(react_bootstrap_1.Card.Title, null, t(ki + '.' + icon[0])),
                    react_1.default.createElement(react_bootstrap_1.Card.Body, { style: { margin: 'auto' } },
                        react_1.default.createElement("svg", { viewBox: '0 0 1000 1000', width: 50, height: 50 },
                            react_1.default.createElement("g", null,
                                react_1.default.createElement("path", { fill: 'black', d: icon[1] })))));
            }));
        });
    }
    // File reader that can process multiple files
    // If the svg contains multiple path, we concat all of them into one big path
    // The icon name is the file name
    const file_import = react_1.default.createElement(react_bootstrap_1.Form.Control, { accept: '.svg', type: "file", multiple: true, ref: _load_svg, style: { display: 'none' }, onChange: (evt) => {
            const files = evt.target.files;
            for (const i in files) {
                const reader = new FileReader();
                reader.onload = (() => {
                    return (e) => {
                        const result = String(e.target.result);
                        const placeholder = document.createElement('div');
                        placeholder.innerHTML = result;
                        const path = d3.select(placeholder).selectAll('path');
                        const attr_d = path.nodes().map(path_to_concat => d3.select(path_to_concat).attr('d')).join(' ');
                        import_svg.current[(files[i].name).replace('.svg', '')] = {
                            path: attr_d,
                            Vb: d3.select(placeholder).select('svg').attr('viewBox')
                        };
                    };
                })();
                if (Number(i) === files.length - 1) {
                    reader.onloadend = (() => {
                        return () => {
                            // import_svg.current=import_svg
                            localStorage.setItem('icon_imported', JSON.stringify(import_svg.current));
                        };
                    })();
                }
                // Permet d'executer la transformation des blob en vues tout en evitant la var length
                //   files : {0:Blob,1:Blob,2:...,n:Blob, length:n-1}
                if (!isNaN(+i)) {
                    reader.readAsText(files[i]);
                }
            }
        } });
    // Card used as a button to open a filereader and import a svg 
    const card_add_svg = react_1.default.createElement(react_bootstrap_1.Card, { style: { borderWidth: '1px' }, bg: 'info', border: 'info', onClick: () => {
            if (_load_svg.current) {
                _load_svg.current.name = '';
                _load_svg.current.click();
            }
        } },
        react_1.default.createElement(react_bootstrap_1.Card.Title, null, t('Import')),
        react_1.default.createElement(react_bootstrap_1.Card.Body, { style: { margin: 'auto' } },
            react_1.default.createElement(fa_1.FaPlus, { style: { width: '5em', height: '5em' } })));
    // List of all imported svg icon
    // WARNING : Those icon disappear whe nwe reload the application (but the icon are still present in the catalog), so 
    const card_imported = Object.keys(import_svg.current).sort(([a,], [b,]) => (a > b) ? 1 : ((b > a) ? -1 : 0)).map((ki) => {
        return react_1.default.createElement(react_bootstrap_1.Card, { style: { borderWidth: allSelectedNodeHasSameicon === 'icon_imported_' + ki ? '2px' : '1px' }, border: (allSelectedNodeHasSameicon === 'icon_imported_' + ki) ? 'primary' : 'light', onClick: () => {
                data.icon_catalog['icon_imported_' + ki] = import_svg.current[ki].path;
                Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => {
                    d.iconName = 'icon_imported_' + ki;
                    d.iconViewBox = import_svg.current[ki].Vb;
                    d.iconColor = '#000000';
                });
                node_function.reDrawIllustration(multi_selected_nodes.current);
                sShowModal(false);
            } },
            react_1.default.createElement(react_bootstrap_1.Card.Title, null, ki),
            react_1.default.createElement(react_bootstrap_1.Card.Body, { style: { margin: 'auto' } },
                react_1.default.createElement("svg", { viewBox: import_svg.current[ki].Vb, width: 50, height: 50 },
                    react_1.default.createElement("g", null,
                        react_1.default.createElement("path", { fill: 'black', d: import_svg.current[ki].path })))));
    });
    tuto_sub_nav['import'] = react_1.default.createElement(react_1.default.Fragment, null,
        card_imported,
        card_add_svg);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Modal, { show: s_show_modal, onHide: () => sShowModal(false), size: 'xl', fullscreen: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true }, t(('Menu.import_icon'))),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Nav, { variant: "tabs", className: 'sub_nav', activeKey: modale_sub_icon }, Object.keys(tuto_sub_nav).map(m => {
                        return react_1.default.createElement(react_bootstrap_1.Nav.Item, null,
                            react_1.default.createElement(react_bootstrap_1.Nav.Link, { eventKey: m, onClick: () => set_modale_sub_icon(m) }, t(m + '.' + m)));
                    }))),
                modale_sub_icon !== 'import' ? react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                    react_1.default.createElement(react_bootstrap_1.InputGroup.Text, null, t('Menu.filter_by_name')),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', value: filter_name, onChange: (evt) => set_filter_name(evt.target.value) })) : react_1.default.createElement(react_1.default.Fragment, null),
                react_1.default.createElement(react_bootstrap_1.Row, { md: 6 }, tuto_sub_nav[modale_sub_icon]))),
        file_import);
};
exports.modal_selection_icons = modal_selection_icons;
